import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import { Fab, Paper, Snackbar, Badge } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import ChatDialog from './ChatDialog';
import { translations } from './config/languages';

const WidgetContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
`;

const ChatButton = styled(Fab)`
  && {
    background-color: #2e3092;
    color: white;
    box-shadow: 0 4px 12px rgba(46, 48, 146, 0.3);
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #1e1f5c;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(46, 48, 146, 0.4);
    }
  }
`;

const StyledBadge = styled(Badge)`
  && .MuiBadge-badge {
    background-color: #ff4444;
    color: white;
  }
`;

const ChatWidget = ({ 
  allowImageUpload = false,
  allowMultilineInput = false,
  language = 'en'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: translations[language].welcomeMessage, isUser: false },
  ]);
  const [error, setError] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleNewMessage = (message) => {
    setMessages(prev => [...prev, { text: message, isUser: true }]);
  };

  const handleBotResponse = (response) => {
    setMessages(prev => [...prev, { text: response, isUser: false }]);
    if (!isOpen) {
      setUnreadCount(prev => prev + 1);
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
    setUnreadCount(0);
  };

  return (
    <WidgetContainer>
      <AnimatePresence>
        {isOpen && (
          <ChatDialog 
            onClose={() => setIsOpen(false)}
            messages={messages}
            onNewMessage={handleNewMessage}
            onBotResponse={handleBotResponse}
            allowImageUpload={allowImageUpload}
            allowMultilineInput={allowMultilineInput}
            language={language}
          />
        )}
      </AnimatePresence>
      
      <StyledBadge badgeContent={unreadCount} color="error" invisible={unreadCount === 0}>
        <ChatButton
          color="primary"
          onClick={handleOpen}
          aria-label={translations[language].chatTitle}
        >
          {isOpen ? <CloseIcon /> : <ChatIcon />}
        </ChatButton>
      </StyledBadge>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        message={error}
      />
    </WidgetContainer>
  );
};

export default ChatWidget; 